import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useSnackbar } from 'notistack'
import { Usuario } from "../../../Models/Cadastros/Usuario/Usuario";
import { useConfirm } from "material-ui-confirm";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import UsuarioCadastroPopup from "./UsuarioCadastroPopup";
import DataGridBuscaComponent from "../../../Components/Forms/DataGridBuscaComponent";

const UsuarioPesquisaPopup = (props: any) => {
    const [openCadastroPopup, setOpenCadastroPopup] = useState(false);
    const [openPopupConfirm, setOpenPopupConfirm] = useState(false);
    const [usuario, setUsuario] = useState<any>(new Usuario());
    const closePopupAction = () => setOpenPopupConfirm(false);
    const handleCloseCadastroPopup = () => setOpenCadastroPopup(false);
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();

    const openCadastroPopupEventCallback = () => {
        setUsuario(new Usuario());
        setOpenCadastroPopup(true);
    }

    const editarUsuario = async (id: any) => {
        let responseUsuario: any = await axios.get(`buscaUsuarioPorId?id=${id}`);
        setUsuario(responseUsuario.data);
        setOpenCadastroPopup(true);
    };

    const solicitaExcluirUsuario = async (id: any) => {
        await confirm({ title: "Deseja realmente apagar este registro?" });
        enqueueSnackbar(`ID = ${id}`, {variant: 'success'});
    };

    const columns: any[] = [
        { dataIndex: 'nome', title: 'Nome', minWidth: 200, flex: 0.3, },
        { dataIndex: 'email', title: 'E-mail', minWidth: 200, flex: 0.3, },
        { dataIndex: 'nome_usuario', title: 'Usuário', minWidth: 200, flex: 0.2, },
    ];
    
    return (
        <div>
            <BasePopup title="Usuários" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={openCadastroPopupEventCallback}>
                <DataGridBuscaComponent apiBusca="buscaUsuarios" columns={columns} onEditAction={editarUsuario} onDeleteAction={solicitaExcluirUsuario} fieldId='usuario_id' />
            </BasePopup>

            {openCadastroPopup ? <UsuarioCadastroPopup isOpen={openCadastroPopup} onClose={handleCloseCadastroPopup} usuario={usuario} /> : ''}
        </div>
    );
}

export default UsuarioPesquisaPopup;
